import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "panel", "icon"];
  static values = { open: Boolean };

  connect() {
    if (this.openValue) this.open()
  }
    toggle() {
    this.openValue = !this.openValue;
    this._toggle();
  }

  open() {
    this._toggle(true);
  }

  close() {
    this._toggle(false);
  }

  _toggle(force) {
    this.panelTarget.classList.toggle("grid-rows-[1fr]", force);
    this.iconTarget?.classList.toggle("-rotate-180", force);
  }
}
